import { lazy } from 'react'

export const FinancialMetricsLazy = lazy(() => import('./FinancialMetrics'))
